import React from "react";
import { Link } from "react-router-dom";
import colors from "../../utils/colors";
import {
  email,
  instagram,
  lineFooter,
  linkedin,
  navLogo,
  whatsapp,
} from "../../assets";

const Footer = () => {
  return (
    <footer style={{ background: colors.dark }}>
      <div className="py-8 sm:py-12 md:py-[3.63rem] px-4 sm:px-6 md:px-10 lg:px-[7.31rem] flex flex-col lg:flex-row gap-8 lg:gap-[5rem]">
        {/* Logo and Description */}
        <div className="flex flex-col gap-6 lg:gap-[1.88rem] lg:w-1/3">
          <img
            src={navLogo}
            className="h-10 w-10 sm:h-12 sm:w-12 lg:h-[4.5rem] lg:w-[4.5rem]"
            alt="Ubimed Logo"
          />
          <p
            style={{ color: colors.grey }}
            className="font-lato text-sm sm:text-base lg:text-[1.125rem] font-normal leading-relaxed lg:leading-[1.375rem] tracking-[0.0112rem]"
          >
            Ubimed Medical Consultation app aims to act as a bridge between the
            patient and possible health solutions.
          </p>

          {/* Social Icons */}
          <div className="flex gap-4 sm:gap-[1.5rem]">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={instagram}
                alt="Instagram"
                className="h-5 w-5 sm:h-6 sm:w-6"
              />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={linkedin}
                alt="LinkedIn"
                className="h-5 w-5 sm:h-6 sm:w-6"
              />
            </a>
            <a href="mailto:lords@lordsforerunner.net">
              <img src={email} alt="Email" className="h-5 w-5 sm:h-6 sm:w-6" />
            </a>
            <a
              href="https://wa.me/+234 9048220660"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={whatsapp}
                alt="WhatsApp"
                className="h-5 w-5 sm:h-6 sm:w-6"
              />
            </a>
          </div>
        </div>

        {/* Footer Navigation Sections */}
        <div className="flex flex-col sm:flex-row flex-wrap gap-8 sm:gap-12 md:gap-16 lg:gap-[9.38rem] lg:w-2/3">
          {/* Quick Links */}
          <div className="flex flex-col gap-3 sm:gap-[1.19rem]">
            <h4 className="font-lato text-base sm:text-lg font-bold tracking-[0.1125rem] text-white whitespace-nowrap">
              Quick links
            </h4>
            {[
              { label: "Home", to: "/" },
              { label: "About us", to: "/about" },
              { label: "Services", to: "" },
              { label: "Contact Us", to: "/help" },
            ].map(({ label, to }) => (
              <Link
                key={label}
                to={to}
                style={{ color: colors.grey }}
                className="font-lato text-sm sm:text-base font-normal tracking-[0.1125rem] whitespace-nowrap hover:underline"
              >
                {label}
              </Link>
            ))}
          </div>

          {/* Health Specialization */}
          <div className="flex flex-col gap-3 sm:gap-[1.19rem]">
            <h4 className="font-lato text-base sm:text-lg font-bold tracking-[0.1125rem] text-white whitespace-nowrap">
              Health Specialization
            </h4>
            {["Gynaecology", "Pediatrics", "Neurology", "Urology"].map(
              (item) => (
                <span
                  key={item}
                  style={{ color: colors.grey }}
                  className="font-lato text-sm sm:text-base font-normal tracking-[0.1125rem] whitespace-nowrap"
                >
                  {item}
                </span>
              )
            )}
          </div>

          {/* Legal */}
          <div className="flex flex-col gap-3 sm:gap-[1.19rem]">
            <h4 className="font-lato text-base sm:text-lg font-bold tracking-[0.1125rem] text-white whitespace-nowrap">
              Legal
            </h4>
            {[
              { label: "Privacy Policy", to: "" },
              { label: "Terms of use", to: "" },
            ].map(({ label, to }) => (
              <Link
                key={label}
                to={to}
                style={{ color: colors.grey }}
                className="font-lato text-sm sm:text-base font-normal tracking-[0.1125rem] whitespace-nowrap hover:underline"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="text-center lg:text-left py-4 px-4 sm:px-6 md:px-10 lg:px-[7.31rem] border-t border-gray-700">
        <p style={{ color: colors.grey }} className="text-xs sm:text-sm">
          &copy; {new Date().getFullYear()} Ubimed. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
